module.exports = __webpack_public_path__ + "img/ly.200cadb3.svg";